// src/app/services/websocket.service.ts
import { Injectable, EventEmitter, HostListener } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  public socket: WebSocket;
  private timeoutInterval: number = 300000; // 5 min
  private timeoutId: any;
  private reconnecting: boolean = false; // Flag to prevent multiple reconnects
  public connectionTimeout: EventEmitter<void> = new EventEmitter();
  public messageSent: EventEmitter<any> = new EventEmitter();
  private missedMessagesBuffer: any[] = []; // Buffer for missed messages when tab is inactive
  private isTabActive: boolean = true;

  constructor() {
    this.handleVisibilityChange();
  }

  connect(url: string, auth: string) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('WebSocket already connected');
      return; // Avoid creating a new connection if one already exists
    }
    this.socket = new WebSocket(url);

    this.socket.onopen = (event) => {
      console.log('WebSocket connection opened..' + new Date().getTime());
      this.reconnecting = false; // Reset the reconnecting flag
      this.resetTimeout();
      this.sendMessage({ type: 'register', uniqueid: auth });
    };

    this.socket.onmessage = (event) => {
      console.log('Received message from server:', event.data);
      if (this.isTabActive) {
        this.messageSent.emit(event.data);
      } else {
        // Buffer the messages when the tab is inactive
        this.missedMessagesBuffer.push(event.data);
      }
      this.resetTimeout();
    };

    this.socket.onclose = (event) => {
      console.log('WebSocket connection closed:', event);
      clearTimeout(this.timeoutId);
      if (!this.reconnecting) {
        this.reconnect(url, auth);
      }
    };

    this.socket.onerror = (error) => {
      console.log('WebSocket error:', error);
      this.resetTimeout();
    };
    this.setTimeout();
  }

  sendMessage(message: any) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      const msg = JSON.stringify(message);
      console.log('Sending message:', msg);
      this.socket.send(msg);
    }
  }

  close() {
    if (this.socket) {
      this.socket.close();
    }
  }
  private setTimeout() {
    this.timeoutId = setTimeout(() => {
      this.connectionTimeout.emit(); // Emit timeout event
      this.close(); // Optionally close the socket
    }, this.timeoutInterval);
  }

  private resetTimeout() {
    clearTimeout(this.timeoutId);
    this.setTimeout();
  }
  reconnect(url, auth) {
    this.reconnecting = true; // Set the reconnecting flag
    this.connect(url, auth);
  }
  private handleVisibilityChange() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        //console.log('Tab is active');
        this.isTabActive = true;

        // Process missed messages
        this.missedMessagesBuffer.forEach((message) => {
          this.messageSent.emit(message);
        });
        this.missedMessagesBuffer = [];
      } else {
        //console.log('Tab is inactive');
        this.isTabActive = false;
      }
    });
  }
}
